<script setup>
import { format } from '@/utils/date-fns';
import { computed } from 'vue';
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';

const props = defineProps({
  start: {
    type: String,
    default: '',
  },
  end: {
    type: String,
    default: '',
  },
  useTextInsteadOfTime: {
    type: Boolean,
    default: false,
  },
});

const formattedStartTime = computed(() => {
  return format(new Date(props.start), 'HH:mm');
});

const formattedEndTime = computed(() => {
  return format(new Date(props.end), 'HH:mm');
});
</script>

<template>
  <BasicBlock
    :icon="['fal', 'clock']"
    :ariaDescription="`${formattedStartTime} - ${formattedEndTime}`"
    :text="`${formattedStartTime} - ${formattedEndTime}`"
  />
</template>
